/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Position Report for a vessel.
 * @export
 * @interface ShipPositionItemShip
 */
export interface ShipPositionItemShip {
    /**
     * 
     * @type {number}
     * @memberof ShipPositionItemShip
     */
    mmsi?: number;
    /**
     * 
     * @type {number}
     * @memberof ShipPositionItemShip
     */
    imo?: number;
}

/**
 * Check if a given object implements the ShipPositionItemShip interface.
 */
export function instanceOfShipPositionItemShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionItemShipFromJSON(json: any): ShipPositionItemShip {
    return ShipPositionItemShipFromJSONTyped(json, false);
}

export function ShipPositionItemShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionItemShip {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
    };
}

export function ShipPositionItemShipToJSON(value?: ShipPositionItemShip | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'imo': value.imo,
    };
}

